module.exports = __webpack_public_path__ + "static/media/CashRegister.7a119067.mp3";